<template>
  <div>
    <page-header header="Create New Data" />

    <draft-hoc
      class="mt-4"
    />
  </div>
</template>

<script>
import {Vue, Component, namespace} from 'nuxt-property-decorator'
import gateway from '@/gateway'
import DraftHoc from './components/DraftHOC.vue'

@Component({
  components: {
    DraftHoc,
  },
})
export default class IndexEditView extends Vue {
  @namespace('indices').Action resetCurrentIndex
  @namespace('indices').State currentIndex

  async created () {
    this.resetCurrentIndex()
    try {
      const firstVersion = {...this.currentIndex, title: 'Create New Data'}
      const response = await gateway.post(`cms/engage/indices/create`, firstVersion)
      const slug = response.data.data.id
      await this.$router.push(`/indices/${slug}`)
    } catch (e) {
      //todo
    }
  }
}
</script>
